import _omitBy from "lodash/omitBy";
// experimentId might be undefined so we need to check for it
var getSamples = function getSamples(experimentId) {
  return function (samples) {
    return _omitBy(samples, function (value) {
      return value.experimentId && value.experimentId !== experimentId;
    });
  };
};
export default getSamples;